import React from 'react';

const PK = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_70"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_70)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#00421A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.974 5.974C15.908 6.57 15.72 7 15.5 7C15.28 7 15.092 6.57 15.026 5.974C14.43 5.908 14 5.72 14 5.5C14 5.28 14.43 5.092 15.026 5.026C15.092 4.43 15.28 4 15.5 4C15.72 4 15.908 4.43 15.974 5.026C16.57 5.092 17 5.28 17 5.5C17 5.72 16.57 5.908 15.974 5.974ZM0 0H6V15H0V0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.97 6.968C17.99 7.143 18 7.32 18 7.5C18 9.985 15.985 12 13.5 12C11.015 12 9 9.985 9 7.5C9 5.015 11.015 3 13.5 3C13.68 3 13.857 3.01 14.032 3.03C12.32 3.26 11 4.727 11 6.5C11 8.433 12.567 10 14.5 10C16.274 10 17.74 8.68 17.97 6.968Z"
        fill="white"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default PK;
